// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const gholdengo: PokeData = {
  "id": 1000,
  "name": "gholdengo",
  "height": 12,
  "weight": 300,
  "base_experience": 275,
  "types": [
    PokeType.STEEL,
    PokeType.GHOST
  ],
  "api_moves": [
    "tackle",
    "night-shade",
    "recover",
    "confuse-ray",
    "substitute",
    "shadow-ball",
    "memento",
    "astonish",
    "metal-sound",
    "power-gem",
    "nasty-plot",
    "make-it-rain"
  ],
  "moves": [
    "tackle",
    "night-shade",
    "confuse-ray",
    "shadow-ball",
    "metal-sound",
    "magnet-bomb",
    "magnet-pull",
    "steel-beam",
    "metal-burst",
    "behemoth-bash",
    "curse",
    "shadow-sneak",
    "shadow-dagger"
  ],
  "evolution_chain": {
    "id": 528,
    "item": null,
    "species": [
      {
        "name": "gimmighoul",
        "order": 976,
        "types": [
          PokeType.GHOST
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "gholdengo",
        "order": 977,
        "types": [
          PokeType.STEEL,
          PokeType.GHOST
        ],
        "evolves_from_species_id": 999,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.OTHER
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 117,
    "speed": 109,
    "ability_power": 173
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
